import React from "react";
import { Dropdown } from "react-bootstrap";
import TagIcon1 from "assets/images/images_new/tag1.svg";
import TagIcon2 from "assets/images/images_new/tag2.svg";
import TagIcon3 from "assets/images/images_new/tag3.svg";
import TagIconDefault from "assets/images/images_new/tagDefault.png";
import Spinner from "components/Loader/Spinner";

export default function QuestionTagSelect({
	TAGS, questionData, toggle, isOpen, changeHandler, isLoading
}) {

	const tagIcon = (tag) => {
		const tags = {
			green: TagIcon1,
			red: TagIcon2,
			yellow: TagIcon3,
			grey: TagIconDefault,
		};
		if (typeof tag !== "string" && typeof tag !== undefined) {
			tag = tag.length > 0 ? tag[0].tag : "grey";
		}

		return tags[tag] !== undefined ? tags[tag] : TagIconDefault;
	};

	const tagLabel = (tag) => {
		const tags = {
			green: "Green",
			red: "Red",
			yellow: "Yellow",
			grey: "No Tag",
		};
		if (typeof tag !== "string" && typeof tag !== undefined) {
			tag = tag.length > 0 ? tag[0].tag : "grey";
		}
		
		return tags[tag] !== undefined ? tags[tag] : "No Tag";
	};

	return (
    <>
      {/*<Dropdown
			isOpen={isOpen}
			toggle={toggle}
			direction="down"
		>

			 <DropdownToggle
			  tag="span"
			  className="badge-dropdown d-inline-flex align-items-center gap-1"
			>
			  {isLoading ? (
			    <Spinner
				  id="mocklist-spinner-tag"
				  className="spinner-border"
				/>
			  ) : (
			    <img src={tagIcon(questionData.tag)} alt="LA" />
			  )}
			  {tagLabel(questionData.tag)}
			</DropdownToggle> */}
      <Dropdown show={isOpen} onToggle={toggle} className="cursor-pointer">
        <Dropdown.Toggle
          as="span"
          className="badge-dropdown d-inline-flex align-items-center gap-1"
          bsPrefix="custom-toggle"
          style={{ width:'max-content'}}
        >
          {/* <img
					src={tagIcon(questionData.tag)}
					alt="LA"
				/>{" "} */}
          {isLoading ? (
            <Spinner id="mocklist-spinner-tag" className="spinner-border" />
          ) : (
            <img src={tagIcon(questionData.tag)} alt="LA" />
          )}
          {tagLabel(questionData.tag)}
        </Dropdown.Toggle>

        <Dropdown.Menu style={styles.menu}>
          {TAGS.map((tag, i) => {
            let item =
              questionData.tag.length > 0 ? questionData.tag[0].tag : "grey";

            if (item !== tag) {
              return (
                <Dropdown.Item
                  key={i}
                  style={styles.item}
                  onClick={() => changeHandler(tag)}
                >
                  <img src={tagIcon(tag)} alt="LA" /> {tagLabel(tag)}
                </Dropdown.Item>
              );
            }
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

const styles = {
  menu: {
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
    backgroundColor: 'white',
    background: 'white',
    minWidth: "135px",
    transform: 'translate(-12px, 40px) !important',
    margin: '0px'
  },

  item: {
    padding: "8px 14px",
    fontSize: "14px",
    cursor: "pointer",
  },
};